export default function checkMaxLengthFactory(maxLength) {
  return function checkMaxLength(value) {
    // If value isn't defined it is considered below maxLength
    if (!value) {
      return true;
    }

    if (typeof value !== "string") {
      throw new Error("checkMaxLength can only validate string inputs");
    }

    const { length } = value;

    if (length <= maxLength) {
      return true;
    }

    return `This field has a maximum character count of ${maxLength}`;
  };
}
